export default __webpack_public_path__ + "static/media/admin-header.6974691e.svg";